import { deiterateAPI } from '@/js/external-js/variableModules/utils/deiterateAPI.util';

export interface MspDetails {
  id: string;
  customerFriendlyName: string;
  customerName: string;
}

export const mspService = {
  /**
   * Get MSP details by ID
   * @param mspId The ID of the MSP
   * @param companyId The current company ID (optional, will be taken from localStorage if not provided)
   */
  getMspDetails: async (mspId: string, companyId?: string): Promise<MspDetails> => {
    try {
      const response = await deiterateAPI.GET<MspDetails>(
        `/v1/msp/${mspId}`,
        {
          backend: 'thalassa',
          companyID: companyId,
        }
      );
      return response;
    } catch (error) {
      console.error('Error fetching MSP details:', error);
      throw error;
    }
  },
};

export default mspService;
